import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import Dialog from 'material-ui/Dialog';
import moment from 'moment';

import { CancelButton, SubmitButtonModal } from '../../../../components/buttons';
import { renderTextArea, renderTextField, renderDateField } from '../../../../components/reduxFields';
import { SaveBulkNoteAction, BulkUpdateWriteOffDateAction } from './actions/ManageClaimActions';
import SmallLoader from './../../../../img/small-loader.gif';
import { showErrorMessage } from './constants/ApiConstants';





const validate = (values) => {
    const errors = {};

    if (!values.date) {
        errors.date = 'Please enter the date'
    }
    // if (!values.notes) {
    //     errors.notes = 'Please enter notes'
    // }
    return errors;
};


class BulkUpdateWriteOffDateModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            claimId: props.claimId ? props.claimId : null,
        }

        this.onDateChange = this.onDateChange.bind(this);
    }

    handleClose = () => {
        this.props.closeDialog();
    }

    onDateChange(input, value) {
        input.onChange(moment(value).format());
        this.setState({ [input.name]: value });
    }

    onSubmitHandler(formProps) {
        this.props.BulkUpdateWriteOffDateAction(this.props.claimIds, formProps.date, this.props.searchObj);
        this.props.closeDialog();
    }

    renderLoading() {
        return (
            <div>
                {this.props.loading ? (
                    <div className="full_loader top0">
                        <div className="small-loader">
                            <img src={SmallLoader} alt="" />
                        </div>
                    </div>
                ) : null}
            </div>
        );
    }

    render() {
        const { handleSubmit } = this.props;
      
        return (
            <div>
                <Dialog
                    className="custom_modal"
                    title='Bulk Update Close/Write Off Date'
                    modal={false}
                    open={true}
                    autoScrollBodyContent={true}
                >
                    {this.renderLoading()}
                    <div className="row">
                        <div className="col-sm-12">
                            <form className="readmin-form custom_form" >
                                <div className="row">
                                    <div className="col-sm-12 require mt-30">
                                        <Field name="date"
                                            // minDate={this.props.toDate}
                                            placeholder="Close/Write Off Date"
                                            locale="en-US"
                                            selected={this.state.date}
                                            onDateChange={this.onDateChange}
                                            openToYearSelection={true}
                                            component={renderDateField} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-sm-12 pt20 btn_rt">
                                        <CancelButton className="mr-15" onTouchTap={this.handleClose} />
                                        <SubmitButtonModal className="ml_15" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} primary={true} label="Save" />
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </Dialog>
            </div>
        );
    }
}

const selector = formValueSelector('LedgerForm');

const mapStateToProps = (state) => {
    return {
        toDate: selector(state,'ToDate')
    };
};

BulkUpdateWriteOffDateModal = reduxForm({
    form: 'BulkUpdateWriteOffDateModal', // a unique identifier for this form
    // validate,
})(BulkUpdateWriteOffDateModal);

export default connect(mapStateToProps, { BulkUpdateWriteOffDateAction })(BulkUpdateWriteOffDateModal);



// WEBPACK FOOTER //
// ./src/modules/Billing/components/manageClaims/BulkUpdateWriteOffDateModal.js